import frameComponents from './lib/frameComponents'
import bodymovin from 'lottie-web'
import animationData from './lib/animationData'

export default {
  animation: {},
  outQueue: false,

  animationQueue: [],
  playing: false,
  queueState: 'stopped',

  waitingInterval: {},

  waitingLoops: [],

  init () {
    var params = {
      container: document.getElementById('lottie'),
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData
    }

    this.animation = bodymovin.loadAnimation(params)

    this.queueAnimationSegment('walkIn')

    this.playQueue()
  },

  queueAnimationSegment (segmentName) {
    if (!segmentName) { return false }
    if (!frameComponents[segmentName]) {
      console.warn('No animation called ' + segmentName + ' found')
      return false
    }
    this.animationQueue.push(frameComponents[segmentName])
    if (this.playing) {
      this.playQueue()
    }
  },

  playQueue () {
    if (!this.animationQueue[0]) { return false }
    this.playing = true
    if (this.queueState !== 'playing') {
      this.queueState = 'playing'
      const playHead = this.animationQueue[0]
      this.animation.playSegments(playHead, true)

      const handler = () => {
        this.animation.goToAndStop(playHead[1] - playHead[0], true)
        this.animation.removeEventListener('loopComplete', handler, false)
        this.animationQueue.splice(0, 1)
        this.pauseQueue()
        if (this.animationQueue.length > 0) {
          this.playQueue()
        }
      }

      this.animation.addEventListener('loopComplete', handler)
    }
  },

  pauseQueue () {
    this.queueState = 'paused'
  },

  stopQueue () {
    this.queueState = 'stopped'
    this.playing = false
  },

  playWaitingLoop () {
    clearInterval(this.waitingInterval)
    let count = 0
    this.queueAnimationSegment(this.waitingLoops[count])
    count++

    if (this.waitingLoops) {
      this.waitingInterval = setInterval(() => {
        /**
        Only queue waiting animation if there's nothing else playing.
        This is useful for Chrome where it would otherwise queue all the
        animations at once when the tab returns from being idle. */
        if (this.queueState !== 'playing') {
          this.queueAnimationSegment(this.waitingLoops[count])
        }
        if (count < this.waitingLoops.length - 1) {
          count++
        } else {
          count = 0
        }
      }, 6000)
    }
  },

  switchPosition (state) {
    if (this.outQueue) {
      this.queueAnimationSegment(this.outQueue)
      this.outQueue = false
    }

    this.waitingLoops = false

    if (state === 'tieIn') {
      this.outQueue = 'tieOut'
      this.waitingLoops = [
        'tieLoopA',
        'tieLoopB',
        'tieLoopC'
      ]
    }

    if (state === 'phoneIn') {
      this.outQueue = 'phoneOut'
      this.waitingLoops = [
        'phoneLoopA',
        'phoneLoopB',
        'phoneLoopC',
        // 'phoneLoopD',
        'phoneLoopE'
      ]
    }

    if (state === 'pointIn') {
      this.outQueue = 'pointOut'
      this.waitingLoops = [
        'pointLoopA',
        'pointLoopB'
      ]
    }

    if (state === 'maglasIn') {
      this.outQueue = 'maglasOut'
      this.waitingLoops = [
        'maglasLoopA',
        'maglasLoopB'
      ]
    }

    if (state === 'notepadIn') {
      this.outQueue = 'notepadOut'
      this.waitingLoops = [
        'notepadLoopA',
        'notepadLoopB'
      ]
    }

    // if (!this.waitingLoops) {
    //   this.waitingLoops = [
    //     'waitingIn',
    //     'waiting',
    //     'waitingOut'
    //   ]
    // }

    if (state !== 'reset') {
      this.queueAnimationSegment(state)
      this.playWaitingLoop()
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/bean-man/index.js